import { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import ErrorCard from "~frontend/components/ErrorCard";
import FullPageCard from "~frontend/components/FullPageCard";
import { InternalLink } from "~frontend/components/Link";

export default function ErrorPage(): ReactElement {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <FullPageCard title="Page Not Found">
        <p>
          <FormattedMessage
            defaultMessage="There's no page here."
            description="Error message when there's no page at that URL"
          />{" "}
          <InternalLink to={"/"}>
            <FormattedMessage
              defaultMessage="Go Home"
              description="Button to go to the home page"
            />
          </InternalLink>
        </p>
      </FullPageCard>
    );
  }
  return <ErrorCard errors={[error]} />;
}
